(function($) {
	$('.folio-detail__inner').css('opacity',1);
	$('.folio-detail__nav > *').on('click',function(){
		$('.folio-detail__inner').css('opacity',0);
		$(this).css('flex-basis','100%');
		if ($(this).hasClass('folio-detail__nav__prev')) {
			$(this).siblings().css('left','+='+$(this).siblings().outerWidth()+'px');
		} else {
			$(this).siblings().css('left','-='+$(this).siblings().outerWidth()+'px');
		}
	});
})( jQuery );  